import { makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export interface ValueType<T> {
    value: T;
    label: string;
    description?: string;
    disabled?: boolean;
    dataTest?: string;
}

export interface ValueWithOnClickType<T> extends ValueType<T> {
    onClick: () => Promise<boolean> | void;
}

export class SelectState<T> {
    public expanded: boolean = false;
    public isVisited: boolean = false;

    public constructor(
        private formInputState: FormInputState<T, unknown>,
        private values: Array<ValueType<T>> | typeof Proxy,
        private placeholder: string
    ) {
        makeAutoObservable(this);
    }

    public get triggerLabel(): string {
        return this.selectValues.find((item) => item.value === this.formInputState.value)?.label ?? this.placeholder;
    }

    public get selectValues(): Array<ValueType<T>> {
        // we need to stringify and parse back the array cause mobx treats it as proxy here
        const array: Array<ValueType<T>> = JSON.parse(JSON.stringify(this.values));
        return array;
    }

    public setExpanded = (expanded: boolean): void => {
        if (!expanded && this.isVisited) {
            this.formInputState.setAsVisited();
            this.isVisited = false;
        }
        if (expanded) {
            this.isVisited = true;
        }
        this.expanded = expanded;
    };

    public setValue = (value: T, disabled: boolean): void => {
        if (disabled === true) {
            return;
        }

        this.formInputState.setValueOnChange(value);
        this.setExpanded(false);
    };

    public unsetValue = (): void => {
        // @ts-expect-error
        this.formInputState.setValueOnChange('');
        this.setExpanded(false);
    };
}
